<template>
  <div
    class="fixed w-full h-full bg-black bg-opacity-90 z-30 flex justify-center items-center"
  >
    <span class="close cursor-pointer z-50" @click="closeWindow"></span>
    <div
      class="max-w-1920 box-border block w-0 min-w-full tw-h-full carousel-wrapper"
    >
      <VueSlickCarousel
        v-bind="settings"
        class="summon-carousel"
        ref="summonCarousel"
      >
        <div
          class="summon-wrapper w-full flex-row justify-center items-center sm:flex-col"
          v-for="(slide, index) in summonData"
          :key="index"
        >
          <div
            class="relative w-734 h-718 flex justify-center items-center -ml-44 lg:w-508 sm:w-full sm:h-full sm:ml-auto"
          >
            <img :src="`${imgPath}${slide.image}`" />
          </div>
          <div
            class="flex flex-col w-full max-w-487 z-10 -ml-8 xl:max-w-400 lg:max-w-308 lg:ml-auto -mr-24 sm:ml-0 sm:px-7 sm:mr-0 sm:max-w-full"
          >
            <span
              class="font-elmessiri text-44 tracking-wider text-white text-shadow-name capitalize"
              v-html="slide.name"
            ></span>
            <p
              class="font-nunito text-grayish-orange mt-6 sm:mt-0 sm:text-xs sm:leading-3"
              v-html="slide.desc"
            ></p>
            <div
              class="mt-6 w-full h-48 bg-white rounded-2xl flex justify-center items-center sm:h-40 sm:mt-4"
            >
              <img class="sm:w-2/5" :src="`${imgPath}${slide.icon}`" />
            </div>
          </div>
        </div>
        <template #prevArrow="arrowOption">
          <div
            class="bg-prev-arrow bg-center bg-cover w-152 h-152 cursor-pointer m-auto z-20 absolute top-1/2 left-0.5/10 transform translate-x-0 -translate-y-1/2 xl:left-0 sm:w-24 sm:h-24 sm:top-4/10"
          ></div>
        </template>
        <template #nextArrow="arrowOption">
          <div
            class="bg-next-arrow bg-center bg-cover w-152 h-152 cursor-pointer m-auto z-20 absolute top-1/2 right-0.5/10 transform translate-x-0 -translate-y-1/2 xl:right-0 sm:w-24 sm:h-24 sm:top-4/10"
          ></div>
        </template>
      </VueSlickCarousel>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
export default {
  components: { VueSlickCarousel },
  props: {
    summonSlider: Array,
  },
  data: function() {
    return {
      imgPath: process.env.VUE_APP_IMG_URL,
      settings: {
        arrows: true,
        dots: false,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    };
  },
  methods: {
    closeWindow: function() {
      this.$store.commit('SUMMON_SECTION/CLOSE_SLIDER');
    },
  },
  computed: {
    ...mapState({
      summonData: state => state.SummonSection.summonData,
    }),
  },
  created: function() {
    this.unwatch = this.$store.watch(
      (state, getters) => getters.activeSummonSlide,
      (newValue, oldValue) => {
        //console.log(`Updating from ${oldValue} to ${newValue}`);
        // Do whatever makes sense now
        //console.log(this.refs);
        this.$refs.summonCarousel.goTo(newValue, true);
      },
    );
  },
  beforeDestroy() {
    this.unwatch();
  },
};
</script>

<style lang="postcss" scoped>
.close {
  @apply absolute right-16 top-12 w-8 h-8 sm:right-6 sm:top-6;
}
.close:before,
.close:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 33px;
  width: 2px;
  background-color: #f1dcac;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}
.summon-carousel >>> .slick-list {
  @apply w-full h-1087 sm:h-auto;
}
.summon-carousel >>> .slick-list .slick-track .slick-slide {
  @apply w-full relative flex justify-center items-center h-1087 sm:h-auto;
}
.summon-wrapper {
  @apply flex !important;
}
</style>
